/**
 * * Типы сервисов откуда импортируются задачи
 */
enum ImportTypeEnum {
	/**
	 * * Без импорта
	 */
	None = 0,
	/**
	 * * Weeek
	 */
	Weeek = 1
}
export default ImportTypeEnum
